import type { TolgeeInstance } from '@tolgee/core';
import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

import { getStaticData, getTolgeeConfig, type TolgeeConfig } from './config';

let tolgeeInstance: TolgeeInstance | null = null;

export const createTolgeeInstance = (
  config?: Partial<TolgeeConfig>
): TolgeeInstance => {
  // Singleton pattern - retorna mesma instância se já existe
  if (tolgeeInstance) {
    return tolgeeInstance;
  }

  const finalConfig = { ...getTolgeeConfig(), ...config };

  const builder = Tolgee().use(BackendFetch());

  const builderWithDevTools = finalConfig.enableDevTools
    ? builder.use(DevTools())
    : builder;

  const builderWithFormatIcu = finalConfig.enableFormatIcu
    ? builderWithDevTools.use(FormatIcu())
    : builderWithDevTools;

  // Adicionar staticData como fallback se habilitado
  // Os JSONs são gerados automaticamente pelo script tolgee-update.sh
  // Mantém uma única fonte de verdade (Tolgee) com fallback automático
  const initOptions: Parameters<typeof builderWithFormatIcu.init>[0] = {
    defaultLanguage: finalConfig.defaultLanguage,
    apiKey: finalConfig.apiKey,
    apiUrl: finalConfig.apiUrl
  };

  if (finalConfig.enableStaticData) {
    initOptions.staticData = getStaticData();
  }

  const instance = builderWithFormatIcu.init(initOptions);

  tolgeeInstance = instance;
  return instance;
};

// Para testes - permite resetar singleton
export const resetTolgeeInstance = (): void => {
  tolgeeInstance = null;
};
